import React from 'react';
import { about, footerLogo, hero, icon1, icon2, icon3, logo, playCircle} from '../../assets';
import { useTranslation } from 'react-i18next';


const Footer = () => {

  const { t, i18n } = useTranslation();
  return (
    <footer className="bg-[#131313] text-[white] md:py-8 md:mt-[160px] mt-[44px]">
      <div className="md:max-w-container max-w-containerSm mx-auto md:flex justify-between pt-[32px] md:pt-0">
        <div className='md:w-[339px]'>
          <h3 className="text-xl font-semibold md:mb-2"><img className="h-[65px]" src={logo}></img></h3>
          <p className='mt-4'>Biznesinizə Yön Verəcək Texnoloji İnnovasiyalar və Komfortlu Ofis Sahələri</p>
        </div>
        <div className='w-[156px] mt-5 md:mt-0 '>  
          <h4 className="text-lg font-semibold mb-2">{t("Əsas keçidlər")}</h4>
          <ul >
            <li className='mb-2'><a href="/" className="hover:underline mb-2 text-[#999999]">{t("Ana səhifə")}</a></li>
            <li className='mb-2'><a href="/services" className="hover:underline  mb-2 text-[#999999]">{t("Xidmətlər")}</a></li>
            <li className='mb-2'><a href="/about" className="hover:underline  mb-2 text-[#999999]">{t("Haqqımızda")}</a></li>
            <li className='mb-2'><a href="/offices" className="hover:underline  mb-2 text-[#999999]">{t("Ofislər")}</a></li>
            <li className='mb-2'><a href="/preferences" className="hover:underline  mb-2 text-[#999999]">{t("Üstünlüklərimiz")}</a></li>
          </ul>
        </div>
        <div className='md:w-[342px] mt-4 md:mt-0'>
          <div>
          <h4 className="text-lg font-semibold mb-2">{t("Əlaqə")}</h4>
          <div className='gap-2 mb-[29px]'>
<p className='text-[#999999]'>Ünvan: Rəşid Behbudov küçəsi</p>
<p className='text-[#999999]'>Əlaqə nömrəsi: +994 55 236 75 00</p>
</div>

      <div className='flex gap-2'>
<img className='h-6 w-6' src={icon1}></img>
<img className='h-6 w-6' src={icon2}></img>
<img className='h-6 w-6' src={icon3}></img>
      </div>
</div>



        </div>
      </div>
      <div className='h-[1px] bg-[#B8B8B8] mt-5'></div>
      <div className="md:max-w-[1320px] max-w-containerSm md:flex justify-between mt-3 md:mt-8 md:text-center text-sm mx-auto pb-5 md:pb-0">
       <p> Af City © {t("Bütün hüquqlar qorunur.")}</p>
       <p> {t("Sayt hazırlandı")}: Birsayt.az</p>
      </div>
    </footer>
  );
};

export default Footer;